<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperMaterialsAndEquipmentsRequests',
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: 'MaterialsAndEquipmentsRequestsModule',
    };
  },
};
</script>
